module.exports = __webpack_public_path__ + "static/media/productos_cacahuate_vaina.c93e1684.jpg";